import NextLink from '~/client/shared/NextLink';

type Props = { href: string };

const HoverGameLink: FC<Props> = ({ children, href }) => (
  <NextLink href={href}>{children}</NextLink>
);

export default HoverGameLink;
